// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React, { Component } from 'react';
import isEqual from 'lodash.isequal';
import Scrollbars from 'react-custom-scrollbars';

export default class SelectUser extends Component {

    state = {
        users: []
    }

    componentDidMount = () => this.setState({ users: this.props.users });

    componentWillReceiveProps = (next) => {
        if (!isEqual(next.users, this.props.users))
            this.setState({ users: next.users });
    }

    renderUser= (user, idx) => (<React.Fragment key={user._id}>
        <div
            className={"config-user-user" + ((this.props.isMulti ? this.props.value.includes(user._id) : this.props.value === user._id) ? " config-user-selected" : "")}
            onClick={() => this.props.onChange(user._id)}
            title={(this.props.isMulti ? "Click to toggle user: " : "Click to select user: ") + user.name}
        >
            <div className={"config-user-icon palette-color-" + String(idx%8)}>
                {user.name ? user.name[0].toUpperCase() : "U"}
            </div>

            <div className="config-user-user-name">
                {user.name}
            </div>

            <div className="config-user-user-email">
                ({user.email})
            </div>
        </div>
    </React.Fragment>);

    render = () => {
        return (<div
            className="config-user" 
            style={this.props.style ?? {}}
        >
            <Scrollbars>
                <div className="config-user-container">
                    {this.state.users.map(this.renderUser)}
                </div>
            </Scrollbars>
        </div>);
    }

}